// extracted by css-extract-rspack-plugin
export default {"icon":"FullAddressPicker_icon__SRte8","wrapper":"FullAddressPicker_wrapper__PXhZW","expandLess":"FullAddressPicker_expandLess__d8E9n","label":"FullAddressPicker_label__rEez6"};